import React from "react";

export const SOURCES = ["Facebook", "Instagram", "TikTok", "X / Twitter", "Reddit", "YouTube", "Google search", "Friend / word of mouth", "Other"];

// Optional "Where did you find us?" multi-select chips.
export function SourcePicker({ value, onChange, testid = "source-picker" }) {
  const toggle = (s) => onChange(value.includes(s) ? value.filter((x) => x !== s) : [...value, s]);
  return (
    <fieldset data-testid={testid} className="mt-3">
      <legend className="text-xs text-[#94A3B8]">Where did you hear about us? <span className="text-[#64748B]">(optional - tick any)</span></legend>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {SOURCES.map((s) => {
          const on = value.includes(s);
          return (
            <button type="button" key={s} onClick={() => toggle(s)} aria-pressed={on}
              data-testid={`${testid}-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`text-xs px-3 py-2 rounded-full border transition-colors ${on ? "border-[#FBBF24] bg-[#FBBF24]/15 text-[#FDE68A]" : "border-blue-900/60 text-[#94A3B8] hover:text-white"}`}>
              {s}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
